import { render } from "./ProductEditBasic.vue?vue&type=template&id=1b6d6c2e&scoped=true"
import script from "./ProductEditBasic.vue?vue&type=script&lang=js"
export * from "./ProductEditBasic.vue?vue&type=script&lang=js"

import "./ProductEditBasic.vue?vue&type=style&index=0&id=1b6d6c2e&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6d6c2e"]])

export default __exports__